import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";

class GlobalSearch extends Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
    }
    state = {
        showInputField: this.props.globalSearchKey && this.props.globalSearchKey.length ? true : false,
        inputValue: this.props.globalSearchKey
    };

    componentDidUpdate = prevProps => {
        if (prevProps.globalSearchKey !== this.props.globalSearchKey) {
            this.setState({
                showInputField: this.props.globalSearchKey && this.props.globalSearchKey.length ? true : false,
                inputValue: this.props.globalSearchKey
            });
        }
    };

    handleGlobalSearch = e => {
        e.preventDefault();
        if (e.target.value.trim().length) {
            this.props.handleGlobalSearch(e.target.value);
        }
    };

    toggleShowInputField = async e => {
        if (this.props?.onSearchClick) this.props?.onSearchClick(!this.state.showInputField);
        await this.setState({ showInputField: !this.state.showInputField });
        if (this.state.showInputField && this.inputRef?.current) {
            this.inputRef.current.focus();
        }
    };

    handleCloseIconClick = () => {
        if (!this.state.inputValue) {
            this.toggleShowInputField();
        }
        this.setState({ inputValue: "" });
        if (this.props.globalSearchKey) {
            this.props.handleGlobalSearch("");
        }
        // this.toggleShowInputField();
    };

    render() {
        const { showInputField } = this.state;
        const { customClass = "", additionalParentClass = "", viewOnly = false, hasAdvancedSearch = false } = this.props;
        return (
            <React.Fragment>
                <div className={`search ${additionalParentClass}`} id="search-global">
                    {showInputField ? (
                        <>
                            <ReactTooltip
                                id="global-search"
                                className="rc-tooltip-custom-class"
                                effect="solid"
                                html={true}
                                place={`bottom`}
                                backgroundColor="#007bff"
                            />
                            <form id="serach-sec" className={viewOnly ? "cursor-disabled" : ""}>
                                <input
                                    type="search"
                                    ref={this.inputRef}
                                    onKeyPress={event => {
                                        if (event.key === "Enter") {
                                            this.handleGlobalSearch(event);
                                        }
                                    }}
                                    onChange={event => {
                                        this.setState({ inputValue: event.target.value });
                                        if (!event.target.value.trim().length) {
                                            this.props.globalSearchKey && this.props.handleGlobalSearch("");
                                        }
                                    }}
                                    value={this.state.inputValue}
                                    placeholder="Search"
                                    disabled={viewOnly}
                                />
                                {hasAdvancedSearch && (
                                    <i
                                        className="fas fa-info-circle search-info-icon mr-3 global-search-info"
                                        data-tip={`
                                    <strong>&& (AND):</strong> Fetches results containing both keywords
                                    <br />
                                    <strong>~~ (OR):</strong> Fetches results containing either keyword
                                    <br />
                                    <br />
                                    <strong>Examples:</strong>
                                    <br />
                                    1. project && compliance -> results containing both "project" and "compliance"
                                    <br />
                                    2. risk ~~ audit -> results containing either "risk" or "audit"
                                    `}
                                        data-for="global-search"
                                    />
                                )}
                                <i className="fas fa-times" onClick={() => !viewOnly && this.handleCloseIconClick()}></i>
                            </form>
                        </>
                    ) : (
                        <div
                            className={`search-icn ${customClass} ${viewOnly ? "cursor-disabled" : ""} `}
                            onClick={() => !viewOnly && this.toggleShowInputField()}
                            data-for={this.props?.isRecommendationLog ? "table-top-icon" : "table-top-icons"}
                            data-tip={`Global Search`}
                        >
                            <img src="/img/search.svg" alt="" />
                        </div>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(GlobalSearch);
